import * as z from 'zod';

export const SortBy = z
  .object({
    key: z.string(),
    order: z.union([z.literal('asc'), z.literal('desc')]),
  })
  .optional();
export type SortBy = z.infer<typeof SortBy>;
